import { useParams } from 'react-router-dom';

import { MilesText } from 'components';

import { getIsNew } from 'utils';

import { retailerStore } from '../../store';

export const Title = () => {
  const name = retailerStore((state) => state.name);

  const { retailerId } = useParams();

  const isNew = getIsNew(retailerId);

  const title = isNew ? 'New Retailer' : name as string;

  return (
    <MilesText
      size='xxl'
      className='font-medium'
    >
      {title}
    </MilesText>
  );
};
